import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardFooter
} from "@/components/ui/card";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
import PartChatDialog from "@/components/PartChatDialog";
import PartImage from "./partImage";
import PartInfo from "./partInfo";
import ChatButton from "./chatButton";
import {
  getDisplayMakeModel,
  getDisplayName,
  getDisplayPrice
} from "./partUtils";
import { usePartOperation } from "./usePartOperation";

const SavedPartCard = ({ savedPart }) => {
  const { messages, isMessagesLoading, isSenderLoading } = useSelector(
    (state) => state.partChat
  );
  const { saveLoading, savedParts, removeLoading } = useSelector(
    (state) => state.parts
  );
  const { user } = useSelector((state) => state.auth);

  const [selectedConversation, setSelectedConversation] = useState(null);
  const { handleChatClick, handleSaveClick } = usePartOperation();

  const part = savedPart?.part || savedPart;

  if (!part) {
    console.warn("Part data is null or undefined");
    return null;
  }

  const isSaved = savedParts?.some(
    (saved) => saved.partId === part?.id && saved.userId === user?.uid
  );

  const displayPrice = getDisplayPrice(part?.price);
  const partName = getDisplayName(part) || "Unknown Part";
  const partYear = part?.year || "N/A";
  const partMakeModel = getDisplayMakeModel(part) || "Unknown";
  const sellerName = part?.sellerName || "Unknown Seller";
  const sellerRating = part?.sellerRating || 0;
  const reviewCount = part?.reviewCount || 0;

  const onChatClick = () => {
    handleChatClick(part, setSelectedConversation);
  };

  const onSaveClick = () => {
    handleSaveClick(part);
  };

  const isLoading = isMessagesLoading || isSenderLoading;

  return (
    <motion.div
      className="h-full"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Card className="overflow-hidden group hover:border-primary hover:shadow-xl transition-shadow duration-300 ease-in-out border h-full flex flex-col bg-card">
        <CardHeader className="p-0 relative">
          <PartImage
            part={part}
            partName={partName}
            partMakeModel={partMakeModel}
            partYear={partYear}
            displayPrice={displayPrice}
          />
        </CardHeader>

        <CardContent className="p-0 flex-grow">
          <PartInfo
            part={part}
            partName={partName}
            partYear={partYear}
            partMakeModel={partMakeModel}
            sellerName={sellerName}
            sellerRating={sellerRating}
            reviewCount={reviewCount}
            onSaveClick={onSaveClick}
            isSaved={isSaved}
            saveLoading={saveLoading}
            removeLoading={removeLoading}
          />
        </CardContent>
        {user?.role === "seller" && user?.uid === part?.sellerId ? null : (
          <CardFooter className="p-0 w-full">
            <ChatButton
              onChatClick={onChatClick}
              part={part}
              isLoading={isLoading}
            />
          </CardFooter>
        )}
      </Card>

      {selectedConversation && (
        <PartChatDialog
          messages={messages}
          conversation={selectedConversation}
          isOpen={!!selectedConversation}
          isMessagesLoading={isMessagesLoading}
          isSenderLoading={isSenderLoading}
          onOpenChange={(open) => {
            if (!open) setSelectedConversation(null);
          }}
        >
          <></>
        </PartChatDialog>
      )}
    </motion.div>
  );
};

export default SavedPartCard;
